import React from 'react';
import './Navbar.css'
import {Link} from 'react-router-dom'
class Navbar extends React.Component{
  render() {
    return (
      <div className='Navbar'>
        <Link to='/' style={{marginLeft:'3rem',textDecoration:'none',color:'black'}}><h1>Movies</h1></Link>
        <Link to='/favourites' style={{textDecoration:'none',color:'black'}} ><h2 style={{marginLeft:'3rem'}}>favourites</h2></Link>
      </div>
    )
  }
}

export default  Navbar;